let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8iD1s")).then(() => parcelRequire('7uPJZ'));